import PropTypes from 'prop-types';
import React from 'react';
import AssessmentSelection from 'assessmentSelection';
import AccountingWidget from '../phaseAccounting/index';
import S from './styles';

const ContractVerification = ({ params }) => <div className={S.container}>
  <AssessmentSelection />
  <AccountingWidget phaseId={params.id} />
</div>;

ContractVerification.propTypes = {
  params: PropTypes.shape({ id: PropTypes.string }),
};

export default ContractVerification;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseContractVerification/index.jsx